import './KeralaDecor.css';

export function BananaLeaf({ position = 'top-left', size = 280, mirror = false, opacity = 0.9, className = '' }) {
  const src = mirror ? '/decor/banana-leaf-mirror.svg' : '/decor/banana-leaf.svg';
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={`kd-banana kd-banana--${position} ${className}`}
      style={{ width: size, opacity }}
    />
  );
}

export function PalmTree({ side = 'left', height = 320, opacity = 0.85, className = '' }) {
  return (
    <img
      src="/decor/palm-tree.svg"
      alt=""
      aria-hidden="true"
      className={`kd-palm kd-palm--${side} ${className}`}
      style={{ height, opacity, transform: side === 'right' ? 'scaleX(-1)' : undefined }}
    />
  );
}

export function OrnateDivider({ className = '' }) {
  return (
    <div className={`kd-divider ${className}`} aria-hidden="true">
      <img src="/decor/divider-scrollwork.svg" alt="" />
    </div>
  );
}

export function HalalSeal({ size = 130, className = '' }) {
  return (
    <img
      src="/decor/halal-seal.svg"
      alt="Halal"
      className={`kd-seal ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function FlameFrame({ children, accent, className = '' }) {
  return (
    <div className={`kd-flame ${className}`} style={accent ? { '--flame-accent': accent } : undefined}>
      <img className="kd-flame__border" src="/decor/flame-frame.svg" alt="" aria-hidden="true" />
      <div className="kd-flame__inner">{children}</div>
    </div>
  );
}
